module.exports = __webpack_public_path__ + "tarcisio_secoli--c722e1bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/candidatos/tarcisio_secoli.jpg
// module id = 172
// module chunks = 0